import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Paper, Typography } from "@mui/material";

import Logo from "../../vendor/tt_logo_lr.png";
import ResetPasswordForm from "./ResetPasswordForm";
import { useNavigate } from "react-router-dom";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function ResetPassword({ stage }) {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Wrapper>
        <Helmet title="Reset Password" />
        <img
          src={Logo}
          alt="Logo Traffic Technology"
          width={400}
          height={120}
          style={{ margin: 16 }}
          onClick={() => {
            navigate("/");
          }}
        />
        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Reset Password
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Enter your email to reset your password
        </Typography>

        <ResetPasswordForm stageCode={stage} />
      </Wrapper>
    </React.Fragment>
  );
}

export default ResetPassword;
